import posthog from 'posthog-js';

import { env } from '@/lib/env';

export function initPostHog(): void {
  if (!env.VITE_POSTHOG_KEY || !env.VITE_POSTHOG_HOST) return;
  posthog.init(env.VITE_POSTHOG_KEY, {
    api_host: env.VITE_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: true,
    autocapture: false,
    disable_session_recording: true,
    sanitize_properties: (properties) => {
      const phiKeys = ['conditions', 'medications', 'allergies', 'content', 'messages', 'notes'];
      const sanitized: Record<string, unknown> = { ...properties };
      for (const key of phiKeys) {
        if (key in sanitized) sanitized[key] = '[REDACTED]';
      }
      return sanitized;
    },
  });
}

export function track(event: string, properties?: Record<string, unknown>): void {
  if (!env.VITE_POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

export function identify(userId: string, properties?: Record<string, unknown>): void {
  if (!env.VITE_POSTHOG_KEY) return;
  posthog.identify(userId, properties);
}

export function resetAnalytics(): void {
  if (!env.VITE_POSTHOG_KEY) return;
  posthog.reset();
}
